<script lang="ts">
    import Gear from "$lib/assets/Gear.svg";
    import Header from "$lib/components/Header.svelte";
    import { onMount } from "svelte";
    import { getModalStore, ProgressRadial } from "@skeletonlabs/skeleton";

    let user_data;
    let fullName;
    let phoneNumber;
    let submitting = false;

    const modalStore = getModalStore();

    onMount(() => {
        user_data = fetch("/api/account", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((resp) => {
                return resp.json();
            })
            .then((res) => {
                fullName = res.full_name;
                phoneNumber = res.phone_number;
            });
    });
</script>

{#if $modalStore[0]}
    {#await user_data}
        <div class="bg-surface-500 p-20 rounded-lg">
            <header class="font-semibold text-3xl p-5">Loading...</header>
            <ProgressRadial class="m-auto" value={undefined} />
        </div>
    {:then}
        <div class="bg-surface-500 p-8 rounded-lg">
            <Header src={Gear} text="Finish Setting Up Your Account" />
            <form
                on:submit={async (e) => {
                    e.preventDefault();
                    submitting = true;
                    fetch("/api/account", {
                        method: "POST",
                        body: JSON.stringify({
                            full_name: fullName,
                            phone_number: phoneNumber,
                        }),
                    }).then((resp) => {
                        if (resp.ok) {
                            modalStore.close();
                        } else {
                            alert("Settings Update Failed");
                            submitting = false;
                        }
                    });
                }}
            >
                <div class="p-1">
                    <label class="label font-semibold mb-[5px]" for="fullName">Full Name</label>
                    <input
                        class="input rounded-lg border-[1px] border-solid border-stone-200"
                        id="fullName"
                        name="fullName"
                        required
                        type="text"
                        bind:value={fullName}
                        placeholder="Full Name"
                    />
                </div>

                <div class="p-1">
                    <label class="label font-semibold mt-[5px] mb-[5px]" for="phoneNumber">Phone Number</label>
                    <input
                        class="input rounded-lg border-[1px] border-[solid] border-[#EEEAE3]"
                        id="phoneNumber"
                        name="phoneNumber"
                        type="tel"
                        bind:value={phoneNumber}
                        placeholder="Phone Number"
                    />
                </div>

                <input
                    type="submit"
                    value="Submit"
                    disabled={submitting}
                    class="my-3 py-2 px-4 rounded-lg text-white transition duration-300 hover:shadow-md hover:cursor-pointer"
                    class:bg-zinc-800={!submitting}
                    class:bg-zinc-200={submitting}
                />
            </form>

            <i>We'll need these details to help set up your subscription.</i>
        </div>
    {/await}
{/if}
